import React from 'react';

export function renderQuestionInput(q, answer, onChange) {
  const handleInput = (value) => onChange(q.id, value);

  const letterPrefix = (index) => String.fromCharCode(97 + index) + ')'; // a), b), c)...

  switch (q.type) {
    case 'boolean':
    case 'boolean_bonus':
    case 'boolean_info':
    case 'boolean_combo':
      return (
        <div>
          <label>
            <input
              type="radio"
              name={`q-${q.id}`}
              value="1"
              checked={String(answer) === '1'}
              onChange={() => handleInput('1')}
            />
            a) Da
          </label>

          <label style={{ marginLeft: '1rem' }}>
            <input
              type="radio"
              name={`q-${q.id}`}
              value="0"
              checked={String(answer) === '0'}
              onChange={() => handleInput('0')}
            />
            b) Ne
          </label>
        </div>
      );

    case 'numeric_integer':
    case 'numeric_percent':
    case 'numeric_decimal':
      return (
        <input
          type="number"
          step="any"
          value={answer || ''}
          onChange={(e) => handleInput(e.target.value)}
        />
      );

    case 'text_info':
    case 'text_score_description':
      return (
        <textarea
          rows="3"
          cols="50"
          value={answer || ''}
          onChange={(e) => handleInput(e.target.value)}
        />
      );

    case 'select_combo_incident': {
      const incidentOptions = [
        { value: '0', text: 'Nema incidenata' },
        { value: '1', text: 'Incident, mjere poduzete' },
        { value: '2', text: 'Incident, bez mjera' },
      ];

      return (
        <div>
          {incidentOptions.map((opt, idx) => (
            <label key={opt.value} style={{ display: 'block' }}>
              <input
                type="radio"
                name={`q-${q.id}`}
                value={opt.value}
                checked={String(answer) === opt.value}
                onChange={() => handleInput(opt.value)}
              />
              {letterPrefix(idx)} {opt.text}
            </label>
          ))}
        </div>
      );
    }

    case 'multi_checkbox': {
      const selected = Array.isArray(answer)
        ? answer.map(String)
        : typeof answer === 'string' && answer
          ? (() => {
              try {
                const parsed = JSON.parse(answer);
                return Array.isArray(parsed) ? parsed.map(String) : [];
              } catch {
                return answer
                  .split(',')
                  .map((x) => x.trim())
                  .filter(Boolean)
                  .map(String);
              }
            })()
          : [];

      const options = q.answers || [];

      if (!options.length) {
        return (
          <p style={{ color: 'gray' }}>
            Nema ponuđenih odgovora za ovo pitanje.
          </p>
        );
      }

      return (
        <div>
          {options.map((opt, idx) => {
            const value = String(opt.id);

            return (
              <label
                key={opt.id}
                style={{ display: 'block', marginBottom: '0.25rem' }}
              >
                <input
                  type="checkbox"
                  checked={selected.includes(value)}
                  onChange={(e) => {
                    const newVal = e.target.checked
                      ? [...selected, value]
                      : selected.filter((item) => item !== value);

                    handleInput(newVal);
                  }}
                />
                <strong>{letterPrefix(idx)}</strong> {opt.text}
              </label>
            );
          })}
        </div>
      );
    }

    default:
      if (q.answers?.length > 0) {
        return q.answers.map((a, idx) => (
          <label
            key={a.id}
            style={{ display: 'block', marginBottom: '0.5rem' }}
          >
            <input
              type="radio"
              name={`question-${q.id}`}
              value={a.id}
              checked={String(answer) === String(a.id)}
              onChange={() => handleInput(a.id)}
              style={{ marginRight: '0.5rem' }}
            />
            <strong>{letterPrefix(idx)}</strong> {a.text}
          </label>
        ));
      }

      return (
        <p style={{ color: 'gray' }}>
          Nepodržan tip pitanja: {q.type}
        </p>
      );
  }
}